<template>
    <div>
        <static-loading-indicator-icon :loading="$store.getters.shouldLoadLocal"/>
        <line-chart ref="chart" :chart-data="formattedData" :options="chartOptions" :height="height" v-if="showChart"></line-chart>
    </div>
</template>

<script>
import LineChart from "../Base/LineChart";
import StaticLoadingIndicatorIcon from "../../StaticLoadingIndicatorIcon";

export default {
    name: "ViewChart",
    components: {StaticLoadingIndicatorIcon, LineChart},

    props: {
        mode: {
            type: String,
            default: 'daily'
        },
        height: {
            type: Number,
            default: 350
        },
        data: {
            type: Array,
            default: null
        }
    },

    computed: {
        showChart() {
          return !this.$store.getters.shouldLoadLocal && this.formattedData !== null;
        },
        formattedData() {
            if(this.data === null)
                return null;

            let days =      this.data.map((s) => s.date);
            let completed = this.data.map((s) => s.completed);
            let viewed =    this.data.map((s) => s.viewed);

            return {
                labels: days,
                datasets: [
                    {backgroundColor: '#23C426', label: "Video completed", data: completed},
                    {backgroundColor: '#0b7c0d', label: "Video viewed", data: viewed},
                ]
            }
        },
        chartOptions() {
            return {
                height: `${this.height}px`,
                position: 'relative',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            stepSize: 1
                        }
                    }]
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
